import { Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { MarketDialogueDto } from "../../autogen/bff-api";
import { useNoticeTypeLabel } from "./marketDialogueLabels";

export const MarketDialogueNoticeType = ({ dialogue }: { dialogue: MarketDialogueDto }) => {
  const { t } = useTranslation();
  const noticeTypeLabel = useNoticeTypeLabel();
  return (
    <>
      {dialogue.noticeSubType ? (
        <Text fontSize="sm">{noticeTypeLabel(dialogue.noticeSubType)}</Text>
      ) : (
        <Text fontSize="sm" color="smMuted">
          {t("The notice type follows from the regulation and the estimated value.")}
        </Text>
      )}
      <Text fontSize="sm" color="smMuted">
        {t("The notice is indicative and links suppliers to this market dialogue.")}
      </Text>
    </>
  );
};
